import ServiceTemplate from '@/components/ServiceTemplate';

export default function NonProfit() {
  const data = {
    title: 'Non-Profit Organization Formation',
    subtitle: 'Establish your tax-exempt non-profit organization with expert guidance.',
    overviewTitle: 'Starting a Non-Profit Organization',
    overviewImage: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a',
    description: [
      'Non-profit organizations serve charitable, educational, religious, or other beneficial purposes while enjoying tax-exempt status. Proper formation and IRS approval are essential for non-profit success.',
      'Forming a non-profit involves state incorporation, applying for 501(c)(3) tax-exempt status with the IRS, and ensuring compliance with numerous regulatory requirements.',
      'Our comprehensive service handles all aspects of non-profit formation, from state incorporation through IRS approval, helping you establish a strong foundation for your mission.'
    ],
    benefits: [
      { title: 'Tax Exemption', description: 'Exempt from federal and often state income taxes.' },
      { title: 'Tax-Deductible Donations', description: 'Donors can deduct contributions on tax returns.' },
      { title: 'Grant Eligibility', description: 'Access foundation grants and government funding.' },
      { title: 'Credibility', description: '501(c)(3) status enhances legitimacy and donor confidence.' },
      { title: 'Limited Liability', description: 'Protect board members and officers from personal liability.' },
      { title: 'Perpetual Existence', description: 'Organization continues beyond founding members.' }
    ],
    process: [
      { title: 'Discovery & Planning', description: 'Comprehensive assessment of your needs and strategic planning for optimal outcomes.' },
      { title: 'Documentation & Filing', description: 'Complete preparation and filing of all required documents with appropriate authorities.' },
      { title: 'Compliance & Support', description: 'Ongoing compliance monitoring, support, and strategic guidance as your needs evolve.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'What is 501(c)(3) status?', answer: '501(c)(3) is an IRS designation for charitable organizations that provides tax exemption and allows donors to deduct contributions.' },
      { question: 'How long does IRS approval take?', answer: 'Form 1023-EZ takes 2-4 weeks, while Form 1023 can take 3-6 months or longer depending on complexity and IRS workload.' },
      { question: 'What qualifies as a charitable purpose?', answer: 'Charitable, educational, religious, scientific, literary, public safety testing, amateur sports, and prevention of cruelty purposes qualify.' },
      { question: 'Can non-profits make money?', answer: 'Yes, non-profits can generate revenue but profits must be used for the organization\'s mission, not distributed to individuals.' },
      { question: 'Do I need a board of directors?', answer: 'Yes, non-profits must have a board of directors, typically at least three independent members.' },
      { question: 'What are the ongoing requirements?', answer: 'Annual IRS Form 990 filing, state annual reports, board meetings, and maintaining proper records and policies.' },
      { question: 'Can founders be paid?', answer: 'Yes, reasonable compensation for services is allowed, but excessive compensation can jeopardize tax-exempt status.' },
      { question: 'What if application is denied?', answer: 'We can appeal denials or modify the application to address IRS concerns and reapply.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
